/**
 * Copyright © Veeam Software Group GmbH.
 */

import { FormValidator } from '@veeam-vspc/shared/components';
import { VbrDeploymentLicenseSourceType } from '@veeam-vspc/models/web-controllers';

import type { FormErrors } from '@veeam-vspc/shared/components';
import type { VspcLang } from 'configs/languages';

import { REG_EXP } from 'core/const';

import type { VbrDeploySettingsWizardModel } from '../../entries';

export const formValidate = (lang: VspcLang) => (data: VbrDeploySettingsWizardModel): FormErrors<VbrDeploySettingsWizardModel> => {
    const validator = new FormValidator(data);

    if (data.licenseSource === VbrDeploymentLicenseSourceType.LicenseFile) {
        const fileTypeValidator = (value: FileList): string => {
            const fileName = value[0].name;
            const regExp = REG_EXP.licenseFileType;

            return regExp.test(fileName) ? '' : lang.UNSUPPORTED_LICENSE_FORMAT;
        };

        validator.validate('licenseFile')
            .object()
            .required()
            .check(fileTypeValidator);
    }

    return validator.result();
};
